function getFullImageUrl(imagePath) {
    return (`${process.env.STRAPI_API_URL}${imagePath}`);
}

function buildRefToFooter(footerId) {
    return (`#${footerId}`)
}

function buildFooterOriginId(footerId) {
    return (`origin_${footerId}`)
}

function buildRefToFooterOrigin(footerId) {
    return (`#${buildFooterOriginId(footerId)}`)
}

function buildTestimonialId(testimonialId) {
    return (`testimonial_${testimonialId}`)
}

function buildRefToTestimonial(testimonialId, testimonialsPageSlug) {
    return (`${testimonialsPageSlug}/#${buildTestimonialId(testimonialId)}`)
}

function joinClassNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

function getHref(link, language) {
    if (!link) return '';

    if (!link?.ExternalURL && !link?.Page?.Slug && !link?.BlogArticle?.Slug) {
        console.log('Broken internal link (no Page slug, no Blog slug):', link);
    }

    if (link?.ExternalURL) return link.ExternalURL;

    const pageSlug = link?.Page?.Slug;
    if (pageSlug) {
        const base = `/${language}/${pageSlug}`;
        return link?.SectionId != null ? `${base}#${link.SectionId}` : base;
    }

    const blogSlug = link?.BlogArticle?.Slug;
    if (blogSlug) {
        const base = `/${language}/blog/${blogSlug}`;
        return link?.SectionId != null ? `${base}#${link.SectionId}` : base;
    }

    if (link?.SectionId != null) return `#${link.SectionId}`;
    return '';
}

function buildIsoFromDateTime(dateStr, timeStr) {
    if (!dateStr) return null;
    const tt = padTime(timeStr);
    return `${dateStr}T${tt}:00`;
}

function formatTimeRange(startIso, endIso, locale = "de-DE") {
    try {
        const start = new Date(startIso);
        const end = new Date(endIso);
        const opts = { hour: "2-digit", minute: "2-digit" };
        const s = start.toLocaleTimeString(locale, opts);
        const e = end.toLocaleTimeString(locale, opts);
        return `${s}–${e}`;
    } catch {
        return undefined;
    }
}

function padTime(t) {
    if (!t) return "00:00";
    const s = String(t).trim();
    const [h, m = "00"] = s.split(":");
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

function isFutureOrNow(iso) {
    try {
        return new Date(iso).getTime() >= Date.now();
    } catch {
        return true;
    }
}

function formatDate(iso, locale = "de-DE") {
    try {
        const d = new Date(iso);
        return d.toLocaleDateString(locale, { day: "2-digit", month: "2-digit", year: "numeric" });
    } catch {
        return iso;
    }
}

const getStaticPath = (url) => {
    if (!url) return '';
    const filename = url.split('/').pop();
    return `/uploads/${filename}`;
};

module.exports = {
    getFullImageUrl,
    buildRefToFooter,
    buildFooterOriginId,
    buildRefToFooterOrigin,
    buildTestimonialId,
    buildRefToTestimonial,
    joinClassNames,
    getHref,
    buildIsoFromDateTime,
    formatTimeRange,
    padTime,
    formatDate,
    isFutureOrNow,
    getStaticPath
};